// Slug-jelölő — a szerkesztő-sheet fejlécében a stabil azonosítót (slug) monospace szöveggel + kis ikonnal
// tünteti fel, hogy vizuálisan is egyértelmű legyen: ez egy technikai azonosító (nem szabad szöveg). A nagyobb
// rendszerek (GitHub/Linear/Vercel) mintája: slug = monospace + diszkrét ikon; a `title` a képernyőolvasónak is szól.
import { HashtagIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

/** A slug (stabil azonosító) diszkrét, monospace megjelenítése egy vezető #-ikonnal. */
export function SlugHint({ slug }: { slug: string }): JSX.Element {
  const { t } = useTranslation();
  const hint = t('common.slugHint');
  return (
    <span className="inline-flex min-w-0 items-center gap-1" title={hint}>
      <HashtagIcon className="size-3.5 shrink-0 opacity-70" aria-hidden />
      <span className="sr-only">{hint}: </span>
      <span className="truncate font-mono">{slug}</span>
    </span>
  );
}
